import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { WorkOrderChangeObjectVolumesTransferInput } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerMoveWorkOrderChangeObjectRemindersGql } from '../../WorkOrderChangeQueries';

const requestId = 'uerMoveWorkOrderChangeObjectReminders';

interface IUseUerMoveWorkOrderChangeObjectReminders {
    onSuccess: () => void;
}
export const useUerMoveWorkOrderChangeObjectReminders = (props: IUseUerMoveWorkOrderChangeObjectReminders) => {
    const dispatch = useDispatch();
    const { onSuccess } = props;

    const [uerMoveWorkOrderChangeObjectRemindersReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerMoveWorkOrderChangeObjectRemindersReset(undefined);
        onSuccess();
    }, [onSuccess, uerMoveWorkOrderChangeObjectRemindersReset]);

    const [, uerMoveWorkOrderChangeObjectRemindersStatus, , uerMoveWorkOrderChangeObjectRemindersRequest] = useRequest({
        requestId,
        query: uerMoveWorkOrderChangeObjectRemindersGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerMoveWorkOrderChangeObjectRemindersMakeRequest = useCallback(
        (input: WorkOrderChangeObjectVolumesTransferInput) => {
            uerMoveWorkOrderChangeObjectRemindersReset(undefined);

            dispatch(uerMoveWorkOrderChangeObjectRemindersRequest({ input }));
        },
        [dispatch, uerMoveWorkOrderChangeObjectRemindersRequest, uerMoveWorkOrderChangeObjectRemindersReset],
    );

    return {
        uerMoveWorkOrderChangeObjectRemindersStatus,
        uerMoveWorkOrderChangeObjectRemindersMakeRequest,
    };
};
